import { getProductListData, _getPRDataById } from '../products/mockData'
import { getTsdContactListData, _getTCTDataById } from '../tsdContacts/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import {
  getOpportunityListData,
  getOpportunityDataById,
  getOpportunityOverviewData,
} from '../opportunities/mockData'
import { getOpportunityMasterServiceDataById } from '../opportunityMasterServices/mockData'
import { getOpportunityMSServiceDocumentListDataByOMSSId } from '../opportunityMSServiceDocuments/mockData'
import { getOpportunityMSServiceNoteListDataByOMSSId } from '../opportunityMSServiceNotes/mockData'
import { getCompanyDataById } from '../companies/mockData'
import { _storeEntityDataListToLocalForage } from '../../modules/mockDataStorageManager'
import { getSupplierProductListData } from '../supplierProducts/mockData'
import { getSupplierProductItemListData } from '../supplierProductItems/mockData'
import {
  getItemAvailabilityStateById,
  ItemAvailabilityIds,
} from '~/cynqueModules/dataObjects/ItemAvailabilityStatus'
import { getRecursPaidIntervalByLabel } from '~/services/selectLists'
import {
  MSService,
  buildMSServicesById,
} from '~/cynqueModules/dataObjects/MSService'
import { setKeyIdentifierValues } from '../../modules/setKeyIdentifierValues'
import {
  getOpportunityMSServiceStatusByLabel,
  getOpportunityMSServiceStatusById,
  OpportunityMSServicesStatusIds,
} from '~/services/selectLists/opportunityMSServicesStatii'
import { assertIsString, assertIsNotUndefined } from '~/types/models'
import type { TProduct } from '~/types/product/models'
import type { TMasterService } from '~/types/masterService/models'
import type {
  IOpportunityMSService,
  IOpportunityMasterService,
} from '~/types/opportunity/models'
import type { TEntityId } from '~/types/models'
import type { ISupplierProduct } from '~/types/supplierProduct/models'
import type { ISupplierProductItem } from '~/types/supplierProductItem/models'
import { propagateOMSServicesData } from '~/cynqueModules/dataObjects/OpportunityMSService'

const mn = '[api/msw/api/opportunityMSServices/mockData.ts]'

const opportunityMSServiceListData =
  undefined as unknown as IOpportunityMSService[]

export const getOpportunityMSServiceListData = getListDataFunctionFactory<
  IOpportunityMSService[]
>({
  listData: opportunityMSServiceListData,
  storageKey: 'opportunitymsservices',
  getStartingListData: getStartingOpportunityMSServiceListData,
})

export async function getOpportunityMSServiceDataById(
  id: string
): Promise<IOpportunityMSService> {
  const list = await getOpportunityMSServiceListData()
  if (!list) {
    throw new Error(`getOpportunityMSServiceListData returned undefined/null`)
  }
  const omss = list.find((omss: IOpportunityMSService) => omss.id === id)
  if (!omss) {
    throw new Error(`Can't find opportunityMSService for id '${id}'`)
  }
  await setKeyIdentifierValues([omss])
  return omss
}

export async function _getOMSSListDataByOMSId(
  id: TEntityId,
  list: IOpportunityMSService[]
): Promise<IOpportunityMSService[]> {
  if (!list) {
    throw new Error(`_getOMSSListDataByOMSId called with undefined/null list`)
  }
  const omssList = list.filter(
    (omss: IOpportunityMSService) => omss.masterService.id === id
  )
  // console.debug('11111111111111111111111111111111111111111111111111111111111')
  // console.debug(id, omssList)
  // console.debug('11111111111111111111111111111111111111111111111111111111111')
  if (!omssList) {
    throw new Error(
      `Can't find any opportunityMSServices for masterService id '${id}'`
    )
  }
  for (const omss of omssList) {
    omss.opportunityMSServiceDocuments =
      await getOpportunityMSServiceDocumentListDataByOMSSId(omss.id)
    omss.opportunityMSServiceNotes =
      await getOpportunityMSServiceNoteListDataByOMSSId(omss.id)
  }
  await setKeyIdentifierValues(omssList)
  return omssList
}

export async function getOpportunityMSServiceListDataByOMSId(
  id: string
): Promise<IOpportunityMSService[]> {
  const list = await getOpportunityMSServiceListData()
  return _getOMSSListDataByOMSId(id, list)
}

export async function getCompanyDataByOpportunityMSServiceId(id: string) {
  const omss = await getOpportunityMSServiceDataById(id)
  if (!omss) {
    throw new Error(`getOpportunityMSServiceDataById returned undefined/null`)
  }
  assertIsString(omss.masterService.id)
  const oms = await getOpportunityMasterServiceDataById(omss.masterService.id)
  if (!oms) {
    throw new Error(
      `getOpportunityMasterSServiceDataById returned undefined/null`
    )
  }
  assertIsString(oms.opportunity.id)
  const opportunity = await getOpportunityDataById(oms.opportunity.id)
  if (!oms) {
    throw new Error(
      `getOpportunityMasterSServiceDataById returned undefined/null`
    )
  }
  assertIsString(opportunity.company.id)
  const company = await getCompanyDataById(opportunity.company.id)
  if (!company) {
    throw new Error(`getCompanyDataById returned undefined/null`)
  }
  return company
}

export async function updateMasterServiceInOpportunityMSServices({
  targetItem: masterService,
}: {
  targetItem: TMasterService
}) {
  const fn = `${mn} updateMasterServiceInOpportunityMSServices |`
  const list: IOpportunityMSService[] = await getOpportunityMSServiceListData()
  if (!list) {
    throw new Error(`getOpportunityMSServiceListData returned undefined/null`)
  }
  for (const opportunityMSService of list) {
    if (opportunityMSService.masterService.id === masterService.id) {
      console.debug(
        `${fn} updating masterService.label in opportunityMSService` +
          ` from ${opportunityMSService.masterService.label} to ${masterService.descr}`
      )
      opportunityMSService.masterService = {
        id: masterService.id,
        label: masterService.descr,
        parent: opportunityMSService.masterService.parent,
      }
    }
  }
  await _storeEntityDataListToLocalForage({
    entityKeyBase: 'opportunitymsservices',
    listData: list,
    callingFn: fn,
  })
}

//
// propagation
//

export async function propagateOpportunityMSServiceOrServicesAdditions({
  newEntityData,
}: {
  newEntityData: IOpportunityMSService | IOpportunityMSService[]
}) {
  const fn = `${mn} propagateOpportunityMSServiceOrServicesAdditions |`
  if (!newEntityData) {
    console.debug(`${fn} newEntityData is falsey. Nothing to propagate.`)
    return
  }
  if (Array.isArray(newEntityData)) {
    if (newEntityData.length < 1) {
      console.debug(
        `${fn} newEntityData is an empty array. Nothing to propagate.`
      )
      return
    }
    _propagateOpportunityMSServiceAdditionsChangesOrDeletions({
      opportunityMSService: newEntityData[0],
    })
    return
  }
  _propagateOpportunityMSServiceAdditionsChangesOrDeletions({
    opportunityMSService: newEntityData,
  })
}

export async function propagateOpportunityMSServicesChanges({
  updatedEntityDataMultiple,
}: {
  updatedEntityDataMultiple: Partial<IOpportunityMSService>[]
}) {
  const fn = `${mn} propagateOpportunityMSServicesChanges |`
  if (
    !updatedEntityDataMultiple ||
    !Array.isArray(updatedEntityDataMultiple) ||
    updatedEntityDataMultiple.length < 1
  ) {
    console.debug(
      `${fn} updatedEntityDataMultiple is falsey ` +
        ` or an empty array. Nothing to propagate.`
    )
    return
  }
  const updatedEntityData = updatedEntityDataMultiple[0]
  if (!updatedEntityData) {
    throw new Error(
      `${fn} updatedEntityData is falsey after testing truthy.` +
        ` This should never happen.`
    )
  }
  assertIsString(updatedEntityData.id)
  const omss = await getOpportunityMSServiceDataById(updatedEntityData.id)
  if (!omss) {
    throw new Error(`getOpportunityMSServiceDataById returned undefined/null`)
  }
  _propagateOpportunityMSServiceAdditionsChangesOrDeletions({
    opportunityMSService: omss,
  })
}

export async function propagateOpportunityMSServiceChanges({
  targetItem,
}: {
  targetItem: IOpportunityMSService
}) {
  const fn = `${mn} propagateOpportunityMSServiceChanges |`
  if (!targetItem) {
    console.debug(`${fn} targetItem is falsey. Nothing to propagate.`)
    return
  }
  _propagateOpportunityMSServiceAdditionsChangesOrDeletions({
    opportunityMSService: targetItem,
  })
}

export async function propagateOpportunityMSServiceDeletions({
  deletedEntityData,
}: {
  deletedEntityData: IOpportunityMSService
}) {
  const fn = `${mn} propagateOpportunityMSServiceDeletions |`
  if (!deletedEntityData) {
    console.debug(`${fn} deletedEntityData is falsey. Nothing to propagate.`)
    return
  }
  _propagateOpportunityMSServiceAdditionsChangesOrDeletions({
    opportunityMSService: deletedEntityData,
  })
}

async function _propagateOpportunityMSServiceAdditionsChangesOrDeletions({
  opportunityMSService,
}: {
  opportunityMSService: IOpportunityMSService
}) {
  function _setUpOpportunityMSServices() {
    const msServicesById = buildMSServicesById(allOMSServices)
    allOMSServices.forEach((omsService) => {
      omsService = Object.assign(
        omsService,
        MSService(omsService, allOMSServices, msServicesById)
      )
    })
  }
  //
  // Execution begins here
  //
  const fn = `${mn} _propagateOpportunityMSServiceAdditionsChangesOrDeletions |`
  if (!opportunityMSService) {
    console.debug(`${fn} opportunityMSService is falsey. Nothing to propagate.`)
    return
  }
  const oms = await getOpportunityMasterServiceDataById(
    opportunityMSService.masterService.id
  )
  if (!oms) {
    throw new Error(
      `getOpportunityMasterServiceDataById returned undefined/null`
    )
  }
  const opportunity = await getOpportunityDataById(oms.opportunity.id)
  if (!opportunity) {
    throw new Error(`getOpportunityDataById returned undefined/null`)
  }
  const overviewData = await getOpportunityOverviewData(opportunity.id)
  assertIsNotUndefined(overviewData)
  console.debug(`${fn} overviewData:`, overviewData)

  const allOMSServices: IOpportunityMSService[] =
    overviewData.opportunityMasterServices
      .filter((ms: IOpportunityMasterService) => !!ms.opportunityMSServices)
      .map((ms: TMasterService) => ms.opportunityMSServices)
      .flat()
  console.debug(`${fn} all omss:`, allOMSServices)

  propagateOMSServicesData({
    overviewData,
    allOMSServices,
    setUpOpportunityMSServices: _setUpOpportunityMSServices,
  })
  console.debug(
    `${fn} opportunity after propagation:`,
    overviewData.opportunity
  )

  const opportunityList = await getOpportunityListData()
  if (!opportunityList) {
    throw new Error(`getOpportunityListData returned undefined/null`)
  }
  await _storeEntityDataListToLocalForage({
    entityKeyBase: 'opportunities',
    listData: opportunityList,
    callingFn: fn,
  })
  // Note: I don't understand why I don't have to do the same as above
  // for opportunityMasterServices (get the list and call _store{blah}).
  // The value in localForage -is- getting changed somehow. Even weirder,
  // I -do- have to do that for propagation of companyMSServices
  // changes. JR
}

/**
 * BRANCH OFFICE on XXO0003 -- the optional nested plain Kit (XXPR0068), three
 * times over, one per state the options dialog has to handle. Its own group,
 * XXOMS0012, for the reason XXOMS0010 has one: the seeded lastSelectedState
 * pins XXOMS0005, so the specs that drive the default card see no change.
 *
 *   Boston   Wi-Fi TAKEN -- its header OPTIONAL_INCLUDED, the Access Point
 *            and the Mounting Kit (header and Bracket) MANDATORY, and the
 *            optional Controller License taken too. "Add or Remove Items..."
 *            on the Wi-Fi header removes the lot.
 *   Lake     Wi-Fi REMOVED -- header and contents OPTIONAL_REMOVED, doInclude
 *            off, exactly as the dialog leaves them. Restoring it revives every
 *            one of those rows in place; the License was never taken here, so
 *            it stays out unless picked.
 *   Waltham  Wi-Fi NEVER TAKEN -- no rows at all beneath the router. Taking it
 *            builds the whole Kit from nothing.
 *
 * ⚠ THE NESTED HEADERS CARRY `supplierProduct`, NEVER `supplierProductItem`:
 * the API refuses a row with both (see supplierProductAndItemConflict.ts). The
 * options dialog pairs each with its slot through the slot's
 * `childSupplierProduct` instead.
 *
 * Amounts are the supplier-product items', copied as the build would, so the
 * group's MRC moves when the Kit does.
 */
async function _buildBranchOfficeOpportunityMSServices({
  prListData,
  spListData,
  spiListData,
}: {
  prListData: TProduct[]
  spListData: ISupplierProduct[]
  spiListData: ISupplierProductItem[]
}): Promise<IOpportunityMSService[]> {
  const product = async (id: string) => {
    const found = await _getPRDataById(id, prListData, true)
    assertIsNotUndefined(found)
    return found
  }
  const supplierProductSelectItem = (id: string) => {
    const found = spListData.find((sp) => sp.id === id)
    assertIsNotUndefined(found)
    return { id: found.id, label: found.descr as string }
  }
  const supplierProductItem = (id: string) => {
    const found = spiListData.find((spi) => spi.id === id)
    assertIsNotUndefined(found)
    return found
  }
  const prBranchOffice = await product('XXPR0068')
  const prWiFi = await product('XXPR0069')
  const prMounting = await product('XXPR0070')
  const prRouter = await product('XXPR0066')
  const prAccessPoint = await product('XXPR0071')
  const prLicense = await product('XXPR0072')
  const prBracket = await product('XXPR0073')

  const availability = (id: ItemAvailabilityIds) =>
    getItemAvailabilityStateById(id)

  function row({
    n,
    location,
    descr,
    product,
    parent,
    supplierProductId,
    supplierProductItemId,
    availabilityId,
    kitQuantity,
    doInclude = true,
  }: {
    n: number
    location: { id: string; label: string }
    descr: string
    product: TProduct
    parent?: { id: string; product: TProduct }
    supplierProductId?: string
    supplierProductItemId?: string
    availabilityId?: ItemAvailabilityIds
    kitQuantity: unknown
    doInclude?: boolean
  }): IOpportunityMSService {
    const spi = supplierProductItemId
      ? supplierProductItem(supplierProductItemId)
      : undefined
    return {
      id: `XXOMSS${String(n).padStart(4, '0')}`,
      hrid: `OMSS${String(n).padStart(4, '0')}`,
      descr,
      masterService: {
        id: 'XXOMS0012',
        label: 'Branch Office - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: { id: 1, label: 'New' },
      product,
      parentProduct: parent
        ? { id: parent.product.id, label: parent.product.descr }
        : undefined,
      parentMSServiceId: parent?.id,
      location,
      supplier: { id: 'XXS0002', label: 'Cogent' },
      ...(supplierProductId && {
        supplierProduct: supplierProductSelectItem(supplierProductId),
      }),
      ...(spi && { supplierProductItem: spi }),
      ...(availabilityId && {
        itemAvailabilityState: availability(availabilityId),
      }),
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: spi ? 'M / M' : '--',
      splitFraction: spi ? 0.18 : null,
      // A kit row stores no term; an item takes XXO0003's defaultTerm.
      ...(spi && { term: 24 }),
      kitQuantity,
      quantity: 1,
      unitRcAmount: spi?.unitRcAmount ?? 0,
      mrcAmount: 0,
      unitNrcAmount: spi?.unitNrcAmount ?? 0,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude,
      version: '1',
      canBeDeleted: true,
    } as unknown as IOpportunityMSService
  }

  const boston = { id: 'XXL0001', label: 'Boston' }
  const lake = { id: 'XXL0004', label: 'Lake' }
  const waltham = { id: 'XXL0009', label: 'Waltham' }
  const kitHeader = (n: number, location: typeof boston) =>
    row({
      n,
      location,
      descr: 'Cogent Branch Office (Kit)',
      product: prBranchOffice,
      supplierProductId: 'XXSP0025',
      kitQuantity: '--',
    })
  const router = (n: number, location: typeof boston, parentId: string) =>
    row({
      n,
      location,
      descr: 'Cogent Router - Cisco ISR',
      product: prRouter,
      parent: { id: parentId, product: prBranchOffice },
      supplierProductItemId: 'XXSPI0061',
      availabilityId: ItemAvailabilityIds.MANDATORY,
      kitQuantity: 'kit',
    })
  // The Wi-Fi Kit and everything in it, in one state.
  const wiFi = ({
    first,
    location,
    parentId,
    wiFiAvailabilityId,
    contentsAvailabilityId,
    withLicense,
    doInclude,
  }: {
    first: number
    location: typeof boston
    parentId: string
    wiFiAvailabilityId: ItemAvailabilityIds
    contentsAvailabilityId: ItemAvailabilityIds
    withLicense: boolean
    doInclude: boolean
  }) => {
    const wiFiId = `XXOMSS${String(first).padStart(4, '0')}`
    let n = first
    const rows = [
      row({
        n: n++,
        location,
        descr: 'Wi-Fi',
        product: prWiFi,
        parent: { id: parentId, product: prBranchOffice },
        supplierProductId: 'XXSP0026',
        availabilityId: wiFiAvailabilityId,
        kitQuantity: 'kit',
        doInclude,
      }),
      row({
        n: n++,
        location,
        descr: 'Wi-Fi | Cogent Wi-Fi Access Point',
        product: prAccessPoint,
        parent: { id: wiFiId, product: prWiFi },
        supplierProductItemId: 'XXSPI0063',
        availabilityId: contentsAvailabilityId,
        kitQuantity: 'x2',
        doInclude,
      }),
    ]
    if (withLicense) {
      rows.push(
        row({
          n: n++,
          location,
          descr: 'Wi-Fi | Cogent Wi-Fi Controller License',
          product: prLicense,
          parent: { id: wiFiId, product: prWiFi },
          supplierProductItemId: 'XXSPI0064',
          availabilityId: ItemAvailabilityIds.OPTIONAL_INCLUDED,
          kitQuantity: 'kit',
          doInclude,
        })
      )
    }
    const mountingId = `XXOMSS${String(n).padStart(4, '0')}`
    rows.push(
      row({
        n: n++,
        location,
        descr: 'Mounting',
        product: prMounting,
        parent: { id: wiFiId, product: prWiFi },
        supplierProductId: 'XXSP0027',
        availabilityId: contentsAvailabilityId,
        kitQuantity: 'kit',
        doInclude,
      }),
      row({
        n: n++,
        location,
        descr: 'Mounting | Cogent Mounting Bracket',
        product: prBracket,
        parent: { id: mountingId, product: prMounting },
        supplierProductItemId: 'XXSPI0066',
        availabilityId: contentsAvailabilityId,
        kitQuantity: 'kit',
        doInclude,
      })
    )
    return rows
  }

  return [
    // Boston: taken.
    kitHeader(136, boston),
    router(137, boston, 'XXOMSS0136'),
    ...wiFi({
      first: 138,
      location: boston,
      parentId: 'XXOMSS0136',
      wiFiAvailabilityId: ItemAvailabilityIds.OPTIONAL_INCLUDED,
      contentsAvailabilityId: ItemAvailabilityIds.MANDATORY,
      withLicense: true,
      doInclude: true,
    }), // XXOMSS0138-0142
    // Lake: removed.
    kitHeader(143, lake),
    router(144, lake, 'XXOMSS0143'),
    ...wiFi({
      first: 145,
      location: lake,
      parentId: 'XXOMSS0143',
      wiFiAvailabilityId: ItemAvailabilityIds.OPTIONAL_REMOVED,
      contentsAvailabilityId: ItemAvailabilityIds.OPTIONAL_REMOVED,
      withLicense: false,
      doInclude: false,
    }), // XXOMSS0145-0148
    // Waltham: never taken.
    kitHeader(149, waltham),
    router(150, waltham, 'XXOMSS0149'),
  ]
}

/**
 * ZSCALER DLP - 3 YEAR on XXO0007 -- production's three "Zscaler DLP (n of 3)"
 * kits, which sit at the TOP LEVEL of one service group there, nested here in
 * one Kit (XXPR0074) for the experiment. Every item recurs ANNUALLY, and the
 * terms, quantities, split fractions and unit amounts are production's, row
 * for row -- including where a row's amount differs from its supplier-product
 * item's (edited after the build):
 *
 *   (1 of 3)  term 12   Data Protection x800, Support Essentials,
 *                       Essentials Deployment (RC 8800, not the item's NRC)
 *   (2 of 3)  term 12   Data Protection x'kit', Support Essentials (the 2YR
 *                       item at the 1 YR price), Essentials Deployment
 *                       REMOVED at term 1
 *   (3 of 3)  term 5    Data Protection x800 at 18 (production: 43.20),
 *                       Support Essentials - 3YR at 2800 (production: 6720)
 *
 * The kit is 800 seats. The two Sets have no rows: their items hang off the
 * DLP Kit header, as production's do. The DLP headers carry `supplierProduct`
 * and a descr equal to their slot's -- that is how the options dialog tells
 * the three slots for the same child apart.
 */
async function _buildZscalerDlpOpportunityMSServices({
  prListData,
  spListData,
  spiListData,
}: {
  prListData: TProduct[]
  spListData: ISupplierProduct[]
  spiListData: ISupplierProductItem[]
}): Promise<IOpportunityMSService[]> {
  const product = async (id: string) => {
    const found = await _getPRDataById(id, prListData, true)
    assertIsNotUndefined(found)
    return found
  }
  const supplierProductSelectItem = (id: string) => {
    const found = spListData.find((sp) => sp.id === id)
    assertIsNotUndefined(found)
    return { id: found.id, label: found.descr as string }
  }
  const supplierProductItem = (id: string) => {
    const found = spiListData.find((spi) => spi.id === id)
    assertIsNotUndefined(found)
    return found
  }
  const prThreeYear = await product('XXPR0074')
  const prDlp = await product('XXPR0075')
  const prZscaler = await product('XXPR0078')

  const id = (n: number) => `XXOMSS${String(n).padStart(4, '0')}`

  function row({
    n,
    descr,
    product,
    parent,
    supplierProductId,
    supplierProductItemId,
    availabilityId,
    kitQuantity,
    quantity = 1,
    term,
    splitFraction = null,
    unitRcAmount = 0,
    unitNrcAmount = 0,
    doInclude = true,
  }: {
    n: number
    descr: string
    product: TProduct
    parent?: { id: string; product: TProduct }
    supplierProductId?: string
    supplierProductItemId?: string
    availabilityId?: ItemAvailabilityIds
    kitQuantity: unknown
    quantity?: number
    term?: number
    splitFraction?: number | null
    unitRcAmount?: number
    unitNrcAmount?: number
    doInclude?: boolean
  }): IOpportunityMSService {
    const spi = supplierProductItemId
      ? supplierProductItem(supplierProductItemId)
      : undefined
    return {
      id: id(n),
      hrid: `OMSS${String(n).padStart(4, '0')}`,
      descr,
      masterService: {
        id: 'XXOMS0013',
        label: 'Zscaler DLP - 3 Year',
        parent: { id: 'XXO0007', label: 'Zscaler DLP - 3 Year' },
      },
      origin: { id: 1, label: 'New' },
      product,
      parentProduct: parent
        ? { id: parent.product.id, label: parent.product.descr }
        : undefined,
      parentMSServiceId: parent?.id,
      location: { id: 'XXL0001', label: 'Boston' },
      supplier: { id: 'XXS0011', label: 'AppDirect' },
      ...(supplierProductId && {
        supplierProduct: supplierProductSelectItem(supplierProductId),
      }),
      ...(spi && { supplierProductItem: spi }),
      ...(availabilityId && {
        itemAvailabilityState: getItemAvailabilityStateById(availabilityId),
      }),
      ...(spi && {
        recurs: getRecursPaidIntervalByLabel('Annually'),
        paid: getRecursPaidIntervalByLabel('Annually'),
      }),
      recursPaidDescr: spi ? 'A / A' : '--',
      splitFraction,
      // A kit row stores no term.
      ...(term !== undefined && { term }),
      kitQuantity,
      quantity,
      unitRcAmount,
      mrcAmount: 0,
      unitNrcAmount,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2026-10-07',
      closeByDate: '2026-11-30',
      status: getOpportunityMSServiceStatusByLabel('Bid Accepted')!,
      doInclude,
      version: '1',
      canBeDeleted: true,
    } as unknown as IOpportunityMSService
  }

  const threeYear = { id: id(151), product: prThreeYear }
  const dlpHeader = (n: number, ofThree: number) =>
    row({
      n,
      descr: `Zscaler DLP (${ofThree} of 3)`,
      product: prDlp,
      parent: threeYear,
      supplierProductId: 'XXSP0029',
      availabilityId: ItemAvailabilityIds.MANDATORY,
      kitQuantity: 'kit',
    })
  const item = (
    n: number,
    headerN: number,
    fields: Omit<Parameters<typeof row>[0], 'n' | 'product' | 'parent'>
  ) =>
    row({
      n,
      product: prZscaler,
      parent: { id: id(headerN), product: prDlp },
      availabilityId: ItemAvailabilityIds.OPTIONAL_INCLUDED,
      ...fields,
    })

  return [
    row({
      n: 151,
      descr: 'AppDirect Zscaler DLP - 3 Year (Kit)',
      product: prThreeYear,
      supplierProductId: 'XXSP0028',
      kitQuantity: '--',
      quantity: 800,
    }),
    // (1 of 3) -- production 3de9f3f8.
    dlpHeader(152, 1),
    item(153, 152, {
      descr: 'DLP | Data Protection - 1 Feature',
      supplierProductItemId: 'XXSPI0072',
      kitQuantity: 800,
      term: 12,
      splitFraction: 0.068,
      unitRcAmount: 43,
    }),
    item(154, 152, {
      descr: 'DLP | Support Essentials',
      supplierProductItemId: 'XXSPI0075',
      kitQuantity: 1,
      term: 12,
      splitFraction: 0.065,
      unitRcAmount: 6625,
    }),
    item(155, 152, {
      descr: 'DLP Essentials Deployment',
      supplierProductItemId: 'XXSPI0076',
      kitQuantity: 1,
      term: 12,
      splitFraction: 0,
      unitRcAmount: 8800,
    }),
    // (2 of 3) -- production c4edda56.
    dlpHeader(156, 2),
    item(157, 156, {
      descr: 'DLP |  Data Protection - 1 Feature',
      supplierProductItemId: 'XXSPI0072',
      kitQuantity: 'kit',
      term: 12,
      splitFraction: 0.068,
      unitRcAmount: 43,
    }),
    item(158, 156, {
      descr: 'DLP | Support Essentials',
      supplierProductItemId: 'XXSPI0074',
      kitQuantity: 1,
      term: 12,
      splitFraction: 0.068,
      unitRcAmount: 6625,
    }),
    // Production 73578e09: removed, term 1.
    item(159, 156, {
      descr: 'Zscaler DLP | Essentials Deployment',
      supplierProductItemId: 'XXSPI0076',
      availabilityId: ItemAvailabilityIds.OPTIONAL_REMOVED,
      kitQuantity: 1,
      term: 1,
      splitFraction: 0,
      unitNrcAmount: 6600,
      doInclude: false,
    }),
    // (3 of 3) -- production d0559438. Its two live rows are term 5.
    dlpHeader(160, 3),
    item(161, 160, {
      descr: 'DLP | Data Protection - 1 Feature',
      supplierProductItemId: 'XXSPI0072',
      kitQuantity: 800,
      term: 5,
      splitFraction: 0.068,
      unitRcAmount: 18,
    }),
    item(162, 160, {
      descr: 'Zscaler DLP | Support Essentials - 3YR',
      supplierProductItemId: 'XXSPI0075',
      kitQuantity: 1,
      term: 5,
      splitFraction: 0.065,
      unitRcAmount: 2800,
    }),
  ]
}

export async function getStartingOpportunityMSServiceListData(): Promise<
  IOpportunityMSService[]
> {
  const prListData = await getProductListData()
  const tctListData = await getTsdContactListData()

  const pr0007 = await _getPRDataById('XXPR0007', prListData, true)
  const pr0035 = await _getPRDataById('XXPR0035', prListData, true)
  // TAM - Bronze: level ITEM and NOT `inKitOnly`, so it is legitimately
  // sellable on its own. See XXOMSS0130 below.
  const pr0031 = await _getPRDataById('XXPR0031', prListData, true)

  if (!pr0007 || !pr0035) {
    throw new Error('Some mock data products are falsey')
  }

  function isDefined<T>(
    value: NonNullable<T> | undefined | null
  ): value is NonNullable<T> {
    return value !== null && value !== undefined
  }

  function isEachItemDefined<T>(
    value: Array<NonNullable<T> | undefined | null>
  ): value is Array<NonNullable<T>> {
    return value.every(isDefined)
  }

  const prArray = []
  for (let i = 35; i < 64; i++) {
    if (i === 41) {
      continue
    }
    const id = `${'XXPR00'}${('00' + i.toString()).slice(-2)}`
    prArray[i] = await _getPRDataById(id, prListData, true)
  }

  if (!isEachItemDefined<TProduct>(prArray)) {
    throw new Error('Some mock data service types are falsey')
  }

  const spListData: ISupplierProduct[] = await getSupplierProductListData()
  const spiListData: ISupplierProductItem[] =
    await getSupplierProductItemListData()
  const branchOfficeRows = await _buildBranchOfficeOpportunityMSServices({
    prListData,
    spListData,
    spiListData,
  })
  const zscalerDlpRows = await _buildZscalerDlpOpportunityMSServices({
    prListData,
    spListData,
    spiListData,
  })

  function findSPI(
    productId: string,
    supplierId: string
  ): ISupplierProductItem | undefined {
    return spiListData.find(
      (spi) =>
        spi.product.id === productId &&
        spi.supplierProduct.supplier.id === supplierId
    )
  }

  function findSP(
    productId: string,
    supplierId: string
  ): ISupplierProduct | undefined {
    return spListData.find(
      (sp) => sp.product.id === productId && sp.supplier.id === supplierId
    )
  }

  /**
   * An SPI by its own id.
   *
   * ⚠ findSPI(productId, supplierId) is not safe for kit items in general: a
   * product can hang off more than one of a supplier's supplier-products, and
   * then product+supplier returns whichever comes first. Which one is returned
   * decides `supplierProduct.product` — and therefore whether a row reads as
   * Set-owned or plain-kit-owned, which is the whole point of the SDWAN rows
   * below. Address them by id. Same duplicate-SPI hazard `_selectUid` exists for.
   */
  function findSPIById(id: string): ISupplierProductItem | undefined {
    return spiListData.find((spi) => spi.id === id)
  }

  // The SDWAN group's products sit outside prArray, which spans only
  // XXPR0035-XXPR0063.
  const prSDWANKit = await _getPRDataById('XXPR0019', prListData, true)
  const prConsulting = await _getPRDataById('XXPR0009', prListData, true)
  const prLicense = await _getPRDataById('XXPR0003', prListData, true)
  const prV10Box = await _getPRDataById('XXPR0020', prListData, true)
  // Only reached by the legacy declined row below -- the alternative the user
  // did NOT take out of the SDWAN Device Set.
  const prV120Box = await _getPRDataById('XXPR0021', prListData, true)
  assertIsNotUndefined(prSDWANKit)
  assertIsNotUndefined(prConsulting)
  assertIsNotUndefined(prLicense)
  assertIsNotUndefined(prV10Box)
  assertIsNotUndefined(prV120Box)

  //
  //  START MOCK DATA  START MOCK DATA  START MOCK DATA
  //
  //

  return [
    {
      id: 'XXOMSS0021',
      hrid: 'OMSS0021',
      descr: findSP(prArray[35].id, 'XXS0002')?.descr || prArray[35].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[35],
      parentProduct: undefined,
      parentMSServiceId: undefined,
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProduct: (() => {
        const _sp = findSP(prArray[35].id, 'XXS0002')
        return _sp ? { id: _sp.id, label: _sp.descr } : undefined
      })(),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0002', label: 'DIA - Boston & Lake' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: '--',
      splitFraction: null,
      kitQuantity: '--',
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 0,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusById(
        OpportunityMSServicesStatusIds.ASSIGNED_TO_CONTRACT
      )!,
      doInclude: true,
      fieldSetData:
        '{ "circuitType": "T1", "circuitId": "987654", "handoff": "Multi Mode - 1 Gbps",' +
        ' "autoNegotiation": "Off", "connector": "Optical", "vlanSetTo": "Untagged",' +
        ' "managed": true, "circuitId": "E92-1029333", "gatewayIp": "222.143.100.1",' +
        ' "subnetMask": "255.255.255.0", "broadcastIp": "192.168.10.255",' +
        ' "startingIp": "222.143.100.50",' +
        ' "lecDemark": "543 Oingo Boingo Blvd, Suite 200, San Diego, CA 90234",' +
        ' "carrierEquipment": "Cisco", "equipmentDetails": "Rack 5, 2nd floor" }',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0028',
      hrid: 'OMSS0028',
      descr: findSPI(prArray[44].id, 'XXS0002')?.descr || prArray[44].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[44],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0021',
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(prArray[44].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0002', label: 'DIA - Boston & Lake' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 60,
      mrcAmount: 0,
      unitNrcAmount: 500,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusById(
        OpportunityMSServicesStatusIds.ASSIGNED_TO_CONTRACT
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0034',
      hrid: 'OMSS0034',
      descr: findSPI(prArray[51].id, 'XXS0002')?.descr || prArray[51].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[51],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0021',
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(prArray[51].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0002', label: 'DIA - Boston & Lake' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 100,
      mrcAmount: 0,
      unitNrcAmount: 1000,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusById(
        OpportunityMSServicesStatusIds.ASSIGNED_TO_CONTRACT
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0038',
      hrid: 'OMSS0038',
      descr: findSPI(prArray[56].id, 'XXS0002')?.descr || prArray[56].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[56],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0021',
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(prArray[56].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0002', label: 'DIA - Boston & Lake' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 79,
      mrcAmount: 0,
      unitNrcAmount: 150,
      nrcAmount: 0,
      oneTimeAmount: 250,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusById(
        OpportunityMSServicesStatusIds.ASSIGNED_TO_CONTRACT
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0044',
      hrid: 'OMSS0044',
      descr: findSPI(prArray[62].id, 'XXS0002')?.descr || prArray[62].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[62],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0021',
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(prArray[62].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0002', label: 'DIA - Boston & Lake' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 2,
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 250,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: true,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusById(
        OpportunityMSServicesStatusIds.ASSIGNED_TO_CONTRACT
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },

    //
    // Comcast - Bostonn (new)
    //

    {
      id: 'XXOMSS0046',
      hrid: 'OMSS0046',
      descr: findSP(prArray[35].id, 'XXS0003')?.descr || prArray[35].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[35],
      parentProduct: undefined,
      parentMSServiceId: undefined,
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0003',
        label: 'Comcast',
      },
      supplierProduct: (() => {
        const _sp = findSP(prArray[35].id, 'XXS0003')
        return _sp ? { id: _sp.id, label: _sp.descr } : undefined
      })(),
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: '--',
      splitFraction: null,
      kitQuantity: '--',
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 0,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: false,
      fieldSetData:
        '{ "circuitType": "T1", "circuitId": "987654", "handoff": "Multi Mode - 1 Gbps",' +
        ' "autoNegotiation": "Off", "connector": "Optical", "vlanSetTo": "Untagged",' +
        ' "managed": true, "circuitId": "E92-1029333", "gatewayIp": "222.143.100.1",' +
        ' "subnetMask": "255.255.255.0", "broadcastIp": "192.168.10.255",' +
        ' "startingIp": "222.143.100.50",' +
        ' "lecDemark": "543 Oingo Boingo Blvd, Suite 200, San Diego, CA 90234",' +
        ' "carrierEquipment": "Cisco", "equipmentDetails": "Rack 5, 2nd floor" }',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0053',
      hrid: 'OMSS0053',
      descr: findSPI(prArray[44].id, 'XXS0003')?.descr || prArray[44].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[44],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0046',
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0003',
        label: 'Comcast',
      },
      supplierProductItem: findSPI(prArray[44].id, 'XXS0003'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),

      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 65,
      mrcAmount: 0,
      unitNrcAmount: 550,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: false,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0059',
      hrid: 'OMSS0059',
      descr: findSPI(prArray[51].id, 'XXS0003')?.descr || prArray[51].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[51],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0046',
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0003',
        label: 'Comcast',
      },
      supplierProductItem: findSPI(prArray[51].id, 'XXS0003'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),

      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 130,
      mrcAmount: 0,
      unitNrcAmount: 1200,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: false,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0069',
      hrid: 'OMSS0069',
      descr: findSPI(prArray[62].id, 'XXS0003')?.descr || prArray[62].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[62],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0046',
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0003',
        label: 'Comcast',
      },
      supplierProductItem: findSPI(prArray[62].id, 'XXS0003'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),

      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      kitQuantity: 2,
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 250,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: true,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: false,
      version: '1',
      canBeDeleted: true,
    },
    //
    // Cogent / Lake
    //
    {
      id: 'XXOMSS0071',
      hrid: 'OMSS0071',
      descr: findSP(prArray[35].id, 'XXS0002')?.descr || prArray[35].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[35],
      parentProduct: undefined,
      parentMSServiceId: undefined,
      location: {
        id: 'XXL0004',
        label: 'Lake',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProduct: (() => {
        const _sp = findSP(prArray[35].id, 'XXS0002')
        return _sp ? { id: _sp.id, label: _sp.descr } : undefined
      })(),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: '--',
      splitFraction: null,
      kitQuantity: '--',
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 0,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: true,
      fieldSetData:
        '{ "circuitType": "T1", "circuitId": "987654", "handoff": "Multi Mode - 1 Gbps",' +
        ' "autoNegotiation": "Off", "connector": "Optical", "vlanSetTo": "Untagged",' +
        ' "managed": true, "circuitId": "E92-1029333", "gatewayIp": "222.143.100.1",' +
        ' "subnetMask": "255.255.255.0", "broadcastIp": "192.168.10.255",' +
        ' "startingIp": "222.143.100.50",' +
        ' "lecDemark": "543 Oingo Boingo Blvd, Suite 200, San Diego, CA 90234",' +
        ' "carrierEquipment": "Cisco", "equipmentDetails": "Rack 5, 2nd floor" }',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0078',
      hrid: 'OMSS0078',
      descr: findSPI(prArray[44].id, 'XXS0002')?.descr || prArray[44].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[44],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0071',
      location: {
        id: 'XXL0004',
        label: 'Lake',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(prArray[44].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 60,
      mrcAmount: 0,
      unitNrcAmount: 500,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0084',
      hrid: 'OMSS0084',
      descr: findSPI(prArray[51].id, 'XXS0002')?.descr || prArray[51].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[51],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0071',
      location: {
        id: 'XXL0004',
        label: 'Lake',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(prArray[51].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 100,
      mrcAmount: 0,
      unitNrcAmount: 1000,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0088',
      hrid: 'OMSS0088',
      descr: findSPI(prArray[56].id, 'XXS0002')?.descr || prArray[56].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[56],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0071',
      location: {
        id: 'XXL0004',
        label: 'Lake',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(prArray[56].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36, // its supplier-product item (IP Block /29) STORES 36, which beats XXO0003's default of 24
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 79,
      mrcAmount: 0,
      unitNrcAmount: 150,
      nrcAmount: 0,
      oneTimeAmount: 250,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0094',
      hrid: 'OMSS0094',
      descr: findSPI(prArray[62].id, 'XXS0002')?.descr || prArray[62].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[62],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0071',
      location: {
        id: 'XXL0004',
        label: 'Lake',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(prArray[62].id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      kitQuantity: 2,
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 250,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: true,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    //
    // Comcast - Boston
    //

    {
      id: 'XXOMSS0096',
      hrid: 'OMSS0096',
      descr: findSP(prArray[35].id, 'XXS0003')?.descr || prArray[35].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[35],
      parentProduct: undefined,
      parentMSServiceId: undefined,
      location: {
        id: 'XXL0004',
        label: 'Lake',
      },
      supplier: {
        id: 'XXS0003',
        label: 'Comcast',
      },
      supplierProduct: (() => {
        const _sp = findSP(prArray[35].id, 'XXS0003')
        return _sp ? { id: _sp.id, label: _sp.descr } : undefined
      })(),
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: '--',
      splitFraction: null,
      kitQuantity: '--',
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 0,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: false,
      fieldSetData:
        '{ "circuitType": "T1", "circuitId": "987654", "handoff": "Multi Mode - 1 Gbps",' +
        ' "autoNegotiation": "Off", "connector": "Optical", "vlanSetTo": "Untagged",' +
        ' "managed": true, "circuitId": "E92-1029333", "gatewayIp": "222.143.100.1",' +
        ' "subnetMask": "255.255.255.0", "broadcastIp": "192.168.10.255",' +
        ' "startingIp": "222.143.100.50",' +
        ' "lecDemark": "543 Oingo Boingo Blvd, Suite 200, San Diego, CA 90234",' +
        ' "carrierEquipment": "Cisco", "equipmentDetails": "Rack 5, 2nd floor" }',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0103',
      hrid: 'OMSS0103',
      descr: findSPI(prArray[44].id, 'XXS0003')?.descr || prArray[44].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[44],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0096',
      location: {
        id: 'XXL0004',
        label: 'Lake',
      },
      supplier: {
        id: 'XXS0003',
        label: 'Comcast',
      },
      supplierProductItem: findSPI(prArray[44].id, 'XXS0003'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),

      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 65,
      mrcAmount: 0,
      unitNrcAmount: 550,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: false,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0109',
      hrid: 'OMSS0109',
      descr: findSPI(prArray[51].id, 'XXS0003')?.descr || prArray[51].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[51],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0096',
      location: {
        id: 'XXL0004',
        label: 'Lake',
      },
      supplier: {
        id: 'XXS0003',
        label: 'Comcast',
      },
      supplierProductItem: findSPI(prArray[51].id, 'XXS0003'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),

      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 130,
      mrcAmount: 0,
      unitNrcAmount: 1200,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: false,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0119',
      hrid: 'OMSS0119',
      descr: findSPI(prArray[62].id, 'XXS0003')?.descr || prArray[62].descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[62],
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0096',
      location: {
        id: 'XXL0004',
        label: 'Lake',
      },
      supplier: {
        id: 'XXS0003',
        label: 'Comcast',
      },
      supplierProductItem: findSPI(prArray[62].id, 'XXS0003'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),

      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      kitQuantity: 2,
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 250,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: true,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: false,
      version: '1',
      canBeDeleted: true,
    },

    //
    //  COEO SDWAN KIT (service group XXOMS0010) — the only fixture group that
    //  carries BOTH kinds of optional item, in one flat kit.
    //
    //  Consulting Services (XXSPI0023) is PLAIN-KIT-owned: XXSP0010 "Coeo SDWAN
    //  (Kit)" has product XXPR0019, a plain Kit with NO
    //  doExcludeKitServiceWhenBuildingServices, so isSupplierProductItemFromSet()
    //  is false for it. Its row menu offers "Add or Remove Items...", never
    //  "Swap Item...", and diffOptionSelections records an unticked one as
    //  REMOVED, never SWAPPED_OUT. It is the fixture's only such row, and the
    //  reason this group exists at all.
    //
    //  The four boxes (XXSPI0025-0028: V10Box, V120Box, V180Box, V1800Box) are
    //  SET-owned, through XXSPI0057 -> XXSP0023 "Coeo SDWAN Device (Set)". A
    //  deal takes exactly one, so their rows offer "Swap Item..." instead.
    //  Only V10Box is materialised, because the current model does not persist
    //  options the user declined — so the dialog opens with the Set's four
    //  alternatives and one ticked, which is what makes both directions
    //  reachable by hand.
    //
    //  License (XXSPI0024) stays MANDATORY: the negative case, a row that gets
    //  no options entry at all.
    //
    {
      id: 'XXOMSS0120',
      hrid: 'OMSS0120',
      descr: findSP('XXPR0019', 'XXS0010')?.descr || prSDWANKit.descr,
      masterService: {
        id: 'XXOMS0010',
        label: 'SDWAN - Boston',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prSDWANKit,
      parentProduct: undefined,
      parentMSServiceId: undefined,
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0010',
        label: 'Coeo',
      },
      supplierProduct: (() => {
        const _sp = findSP('XXPR0019', 'XXS0010')
        // `descr` is optional on ISupplierProduct but `label` is required on
        // IEntitySelectItem, so fall back the way `descr:` above does.
        return _sp
          ? { id: _sp.id, label: _sp.descr || prSDWANKit.descr }
          : undefined
      })(),
      kitQuantity: '--',
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: null,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 0,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0121',
      hrid: 'OMSS0121',
      descr: findSPIById('XXSPI0023')?.descr || prConsulting.descr,
      masterService: {
        id: 'XXOMS0010',
        label: 'SDWAN - Boston',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prConsulting,
      parentProduct: {
        id: 'XXPR0019',
        label: 'SDWAN (Kit)',
      },
      parentMSServiceId: 'XXOMSS0120',
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0010',
        label: 'Coeo',
      },
      supplierProductItem: findSPIById('XXSPI0023'),
      // THE PLAIN-KIT-OWNED OPTIONAL ROW. XXSPI0023 is isOptional under
      // XXSP0010, whose product is a plain Kit -- so this row can be added or
      // removed, never swapped.
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      kitQuantity: 'kit',
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: null,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 0,
      nrcAmount: 0,
      oneTimeAmount: 2500,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0122',
      hrid: 'OMSS0122',
      descr: findSPIById('XXSPI0024')?.descr || prLicense.descr,
      masterService: {
        id: 'XXOMS0010',
        label: 'SDWAN - Boston',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prLicense,
      parentProduct: {
        id: 'XXPR0019',
        label: 'SDWAN (Kit)',
      },
      parentMSServiceId: 'XXOMSS0120',
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0010',
        label: 'Coeo',
      },
      supplierProductItem: findSPIById('XXSPI0024'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.MANDATORY
      ),
      kitQuantity: 'kit',
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: null,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 0,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      // Optional and SET-owned: XXSPI0025 is isOptional under XXSP0023, the
      // "SDWAN Device (Set)" the kit reaches through XXSPI0057. A Set member
      // inherits the OUTER kit's parentProduct and parentMSServiceId
      // (KitItem.ts), which is why those two still name XXPR0019/XXOMSS0120.
      id: 'XXOMSS0123',
      hrid: 'OMSS0123',
      descr: findSPIById('XXSPI0025')?.descr || prV10Box.descr,
      masterService: {
        id: 'XXOMS0010',
        label: 'SDWAN - Boston',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prV10Box,
      parentProduct: {
        id: 'XXPR0019',
        label: 'SDWAN (Kit)',
      },
      parentMSServiceId: 'XXOMSS0120',
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0010',
        label: 'Coeo',
      },
      supplierProductItem: findSPIById('XXSPI0025'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      kitQuantity: 'kit',
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: null,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 350,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      // ⚠ LEGACY SHAPE, DELIBERATELY PRESERVED. This is a declined option that
      // was materialized and saved -- what the Add-by-Product / Add-by-Supplier
      // flows did before they stopped persisting unchosen alternatives. Nothing
      // writes a row like this any more, and this fixture must NOT be read as
      // saying otherwise; it is here because PRODUCTION STILL HAS THEM until
      // cynque-api-server#1576 lands -- and, because that migration aborts
      // rather than cascades when a surviving row references one of its
      // targets, possibly after.
      //
      // It earns its place by being the only row in any fixture that
      // `doesQualifyToBeHidden` excludes from the money. Without it, every
      // amount filter in the app is exercised only against rows it lets
      // through, and a filter that had been deleted outright would still look
      // correct in dev, in e2e, and by hand.
      //
      // 🔑 It sits in the SDWAN Device Set beside XXOMSS0123, so it is a real
      // declined ALTERNATIVE (V120Box was offered, V10Box was taken) rather
      // than an item the supplier does not carry -- that would be NOT_AVAILABLE
      // and a different thing. Comcast's DIA kits look like they are missing an
      // IP Block for exactly that other reason: Comcast has no IP Address Block
      // supplier-product at all.
      id: 'XXOMSS0124',
      hrid: 'OMSS0124',
      descr: findSPIById('XXSPI0026')?.descr || prV120Box.descr,
      masterService: {
        id: 'XXOMS0010',
        label: 'SDWAN - Boston',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prV120Box,
      parentProduct: {
        id: 'XXPR0019',
        label: 'SDWAN (Kit)',
      },
      parentMSServiceId: 'XXOMSS0120',
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0010',
        label: 'Coeo',
      },
      supplierProductItem: findSPIById('XXSPI0026'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_NOT_INCLUDED
      ),
      kitQuantity: 'kit',
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: null,
      term: 24, // XXO0003's defaultTerm; see the note on it in opportunities/mockData.ts
      quantity: 1,
      // ⚠ Non-zero on all three of the amounts that do NOT pass through
      // quantity, which is the whole point of the row. A hidden row's MRC is
      // zero however the filters behave -- `deriveMSServiceQuantity` zeroes its
      // quantity and mrcAmount is quantity x rate -- so MRC can never show
      // whether an exclusion is working. nrcAmount, oneTimeAmount and the
      // tcvAmount that follows from oneTimeAmount can.
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 450,
      nrcAmount: 0,
      oneTimeAmount: 300,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusByLabel('Bid Rcvd')!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    /**
     * ⚠ THE ONLY STAND-ALONE (parentless) LEVEL-ITEM msService in the fixtures,
     * and it exists to make one specific defect reachable.
     *
     * `OpportunityMSServiceMenu.vue`'s "Reopen Item" entry lives in a branch
     * gated on `!item.parentMSServiceId`, and until 2026-09-04 that branch had
     * no `doShowReopen` guard -- so Reopen was offered on every CLOSED_WON
     * stand-alone item. Reopening one writes `contract: null`
     * (`_setMSServiceStatus`), severing a signed contract and orphaning the
     * orderMSService that references the row through the NO ACTION FK
     * `order_ms_services.opportunitymsservice_sn`. The row is then REOPENED,
     * contract-less, offered for Delete by the status gate, and refused by the
     * server: Honeybadger 134111024 / 134110338.
     *
     * Every other parentless row here is a KIT, whose branch has always carried
     * the guard -- which is exactly why nothing local could render the bug. The
     * shape that matters is: level ITEM + no parentMSServiceId + CLOSED_WON + a
     * contract. `TAM - Bronze` (XXPR0031) is a member of
     * `Technical Account Manager (Set)` (XXPR0032), matching the production row,
     * which was a stand-alone service originally part of a Set.
     *
     * ⚠ IT MUST NOT BE AN `inKitOnly` PRODUCT. The first version of this fixture
     * used `Access - 10Gb` (XXPR0052), which carries `inKitOnly: true` — a
     * product that cannot be sold outside a kit, so a parentless row of it is
     * not a state the app can legitimately reach. That is fixture data inventing
     * a case rather than reproducing one. TAM - Bronze has no such flag.
     */
    {
      id: 'XXOMSS0130',
      hrid: 'OMSS0130',
      descr: 'TAM - Bronze',
      // ⚠ RingCentral's own service group, not the Cogent/Comcast DIA group
      // where this row used to sit -- see XXOMS0011's comment in
      // opportunityMasterServices/mockData.ts. It is therefore NOT on the
      // overview's default card: XXO0003's lastSelectedState pins XXOMS0005.
      masterService: {
        id: 'XXOMS0011',
        label: 'TAM - Boston',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: pr0031!,
      // Both explicitly `undefined`, not omitted: `parentProduct` is a REQUIRED
      // key on TMSService (typed `IEntitySelectItem | undefined`), so leaving it
      // out is a type error. Same convention as the parentless kit rows above.
      // Nothing encloses this row -- that is what puts it in the ITEM branch.
      parentProduct: undefined,
      parentMSServiceId: undefined,
      location: {
        id: 'XXL0001',
        label: 'Boston',
      },
      supplier: {
        id: 'XXS0005',
        label: 'RingCentral',
      },
      // ⚠ RingCentral's own contract, not Cogent's XXCON0002 where this row used
      // to sit. A contract is supplier-specific and can hold only msServices for
      // its supplier (documentation/rules/contract); this row was the single
      // violation in the fixture. Guarded now by contractSupplierParity.test.ts.
      // XXCON0008 is DRAFT, so this row is Assigned to Contract (not yet won:
      // only signing sets Closed Won, cynque-api-server#1816) and does NOT
      // become a Deal -- the shape this row exists for is unchanged.
      contract: { id: 'XXCON0008', label: 'TAM - Boston' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 0,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusById(
        OpportunityMSServicesStatusIds.ASSIGNED_TO_CONTRACT
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    /**
     * Cogent DIA at WALTHAM -- the fixture's only "Deal": Closed/Won services
     * on a SIGNED, non-MSA contract (XXCON0006). See that contract's comment in
     * api/msw/api/contracts/mockData.ts for why the Deal is seeded here rather
     * than by signing XXCON0002, which must stay DRAFT for manual testing.
     *
     * A duplicate of the `Cogent / Lake` kit above, at a third location, with
     * three changes: Waltham instead of Lake, CLOSED WON instead of Bid Rcvd,
     * and XXCON0006 on every row. Nothing already on XXCON0002 was moved or
     * restatused to make this.
     *
     * ⚠ IT IS A KIT ON PURPOSE. `dealMSService` is anchored on the ROOT's
     * status (`root(mss).status === CLOSED_WON`, walking `parentMSServiceId`)
     * precisely so a kit can never be half-hidden -- which would break
     * `msServicesCard.processedItems`' kit-level walk. A stand-alone row
     * exercises none of that; XXOMSS0130 is already the stand-alone case.
     *
     * ⚠ NON-NULL ASSERTIONS (`prArray[35]!`) where the rows above have none.
     * Those rows predate the typecheck ratchet and each contributes four
     * `TS2532 / TS2322` errors to the committed baseline; copying them verbatim
     * added 21 more and failed `npm run typecheck:ratchet`. The assertions are
     * the file's existing idiom (`...StatusByLabel('Bid Rcvd')!`) and change no
     * runtime behaviour -- a missing product would still throw here, one line
     * later. This is the ONLY way the copy differs from its source.
     *
     * ⚠ NOT Comcast. Every Comcast row in this file is `doInclude: false` --
     * the losing side of a supplier bake-off -- so Comcast services are
     * excluded from the roll-ups no matter what the Deal filter does, and could
     * never show that the filter moved a total.
     */
    {
      id: 'XXOMSS0131',
      hrid: 'OMSS0131',
      descr: findSP(prArray[35]!.id, 'XXS0002')?.descr || prArray[35]!.descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[35]!,
      parentProduct: undefined,
      parentMSServiceId: undefined,
      location: {
        id: 'XXL0009',
        label: 'Waltham',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProduct: (() => {
        const _sp = findSP(prArray[35]!.id, 'XXS0002')
        return _sp ? { id: _sp.id, label: _sp.descr! } : undefined
      })(),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0006', label: 'DIA - Waltham' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: '--',
      splitFraction: null,
      kitQuantity: '--',
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 0,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusById(
        OpportunityMSServicesStatusIds.CLOSED_WON
      )!,
      doInclude: true,
      fieldSetData:
        '{ "circuitType": "T1", "circuitId": "987654", "handoff": "Multi Mode - 1 Gbps",' +
        ' "autoNegotiation": "Off", "connector": "Optical", "vlanSetTo": "Untagged",' +
        ' "managed": true, "circuitId": "E92-1029333", "gatewayIp": "222.143.100.1",' +
        ' "subnetMask": "255.255.255.0", "broadcastIp": "192.168.10.255",' +
        ' "startingIp": "222.143.100.50",' +
        ' "lecDemark": "543 Oingo Boingo Blvd, Suite 200, San Diego, CA 90234",' +
        ' "carrierEquipment": "Cisco", "equipmentDetails": "Rack 5, 2nd floor" }',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0132',
      hrid: 'OMSS0132',
      descr: findSPI(prArray[44]!.id, 'XXS0002')?.descr || prArray[44]!.descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[44]!,
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0131',
      location: {
        id: 'XXL0009',
        label: 'Waltham',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(prArray[44]!.id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0006', label: 'DIA - Waltham' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 60,
      mrcAmount: 0,
      unitNrcAmount: 500,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusById(
        OpportunityMSServicesStatusIds.CLOSED_WON
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0133',
      hrid: 'OMSS0133',
      descr: findSPI(prArray[51]!.id, 'XXS0002')?.descr || prArray[51]!.descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[51]!,
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0131',
      location: {
        id: 'XXL0009',
        label: 'Waltham',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(prArray[51]!.id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0006', label: 'DIA - Waltham' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 100,
      mrcAmount: 0,
      unitNrcAmount: 1000,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusById(
        OpportunityMSServicesStatusIds.CLOSED_WON
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0134',
      hrid: 'OMSS0134',
      descr: findSPI(prArray[56]!.id, 'XXS0002')?.descr || prArray[56]!.descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[56]!,
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0131',
      location: {
        id: 'XXL0009',
        label: 'Waltham',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(prArray[56]!.id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0006', label: 'DIA - Waltham' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 'kit',
      quantity: 1,
      unitRcAmount: 79,
      mrcAmount: 0,
      unitNrcAmount: 150,
      nrcAmount: 0,
      oneTimeAmount: 250,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: false,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusById(
        OpportunityMSServicesStatusIds.CLOSED_WON
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXOMSS0135',
      hrid: 'OMSS0135',
      descr: findSPI(prArray[62]!.id, 'XXS0002')?.descr || prArray[62]!.descr,
      masterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
        parent: { id: 'XXO0003', label: 'DIA - Boston, Lake & Waltham' },
      },
      origin: {
        id: 1,
        label: 'New',
      },
      product: prArray[62]!,
      parentProduct: {
        id: 'XXPR0035',
        label: 'DIA - Kit',
      },
      parentMSServiceId: 'XXOMSS0131',
      location: {
        id: 'XXL0009',
        label: 'Waltham',
      },
      supplier: {
        id: 'XXS0002',
        label: 'Cogent',
      },
      supplierProductItem: findSPI(prArray[62]!.id, 'XXS0002'),
      itemAvailabilityState: getItemAvailabilityStateById(
        ItemAvailabilityIds.OPTIONAL_INCLUDED
      ),
      tsd: {
        id: 'XXT0001',
        hrid: 'T0001',
        descr: 'TBI',
        splitFraction: 0.85,
        spendAmount: 165000,
        numOpenOpportunities: 4,
        numSuppliers: 3,
        numOrders: 180,
        channelManager: _getTCTDataById('XXTCT0002', tctListData),
        relationship: {
          id: 1,
          label: 'Direct',
        },
        lastActivityDate: '2022-03-01',
        status: {
          id: 2,
          label: 'Active',
        },
        version: '1',
        canBeDeleted: false,
      },
      contract: { id: 'XXCON0006', label: 'DIA - Waltham' },
      recurs: getRecursPaidIntervalByLabel('Monthly'),
      paid: getRecursPaidIntervalByLabel('Monthly'),
      recursPaidDescr: 'M / M',
      splitFraction: 0.18,
      term: 36,
      kitQuantity: 2,
      quantity: 1,
      unitRcAmount: 0,
      mrcAmount: 0,
      unitNrcAmount: 250,
      nrcAmount: 0,
      oneTimeAmount: 0,
      tcvAmount: 0,
      doMultiplyNrcByQuantity: true,
      quoteDate: '2022-10-01',
      closeByDate: '2022-04-01',
      status: getOpportunityMSServiceStatusById(
        OpportunityMSServicesStatusIds.CLOSED_WON
      )!,
      doInclude: true,
      version: '1',
      canBeDeleted: true,
    },
    ...branchOfficeRows,
    ...zscalerDlpRows,
  ]
}
